import {
  Icon,
  TableHead,
  TableHeadCell,
  TableRow,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import * as React from 'react'

export const SelectADateHeadCell: React.FC = () => {
  const t = useT()
  const headerTranslation = `Header for scheduling step in service modal.`
  const selectADateCopies = {
    date: t(`Date`, {
      _context: headerTranslation,
    }),
    scheduledServices: t('Scheduled services', {
      _context: headerTranslation,
    }),
    newSchedule: t('New schedule', {
      _context: headerTranslation,
    }),
  }

  return (
    <TableHead>
      <TableRow type="header">
        <TableHeadCell
          header={selectADateCopies.date}
          className="select-a-date-header-cell"
          width="50%"
        />
        <TableHeadCell
          header={selectADateCopies.scheduledServices}
          className="select-a-date-header-cell"
          width="20%"
        />
        <TableHeadCell className="select-a-date-header-cell" width="10%">
          <Icon icon="arrow-right" className="arrow-icon" />
        </TableHeadCell>
        <TableHeadCell
          header={selectADateCopies.newSchedule}
          className="select-a-date-header-cell"
          width="20%"
        />
      </TableRow>
    </TableHead>
  )
}
